(function () {
  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isTouchDevice() {
    return window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
  }

  function useNativeMobileScroll() {
    return isMobileViewport() && isTouchDevice();
  }

  function setActiveMedia(sliderEl, activeIndex) {
    if (window.MediaLazy && typeof window.MediaLazy.setActiveSlide === 'function') {
      window.MediaLazy.setActiveSlide(sliderEl, activeIndex);
      return;
    }

    var slides = sliderEl.querySelectorAll('.splide__slide');
    slides.forEach(function (slide, index) {
      slide.querySelectorAll('video').forEach(function (video) {
        if (index === activeIndex) {
          video.muted = true;
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
        }
      });
    });
  }

  function initCustomdownSlider() {
    var sliderEl = document.querySelector('[data-customdown-slider]');
    if (!sliderEl) return;

    if (window.MediaLazy && typeof window.MediaLazy.syncViewportMedia === 'function') {
      window.MediaLazy.syncViewportMedia(sliderEl);
    }

    if (useNativeMobileScroll()) {
      initNativeMobileSlider(sliderEl);
      return;
    }

    if (typeof Splide === 'undefined') return;
    initSplideSlider(sliderEl);
  }

  function initNativeMobileSlider(sliderEl) {
    var root = document.documentElement;
    var sectionHeader = document.querySelector('.section-header');
    var slides = sliderEl.querySelectorAll('.splide__slide');
    var slideRatios = new Map();
    var lastActiveIndex = -1;

    sliderEl.classList.add('customdown-slider--native-mobile');
    root.classList.add('customdown-scroll-active');

    function updateHeaderState(index) {
      if (sectionHeader) {
        sectionHeader.classList.toggle('header-has-bg', index > 0);
      }
    }

    function updateActiveMedia(index) {
      if (index === lastActiveIndex) return;
      lastActiveIndex = index;
      setActiveMedia(sliderEl, index);
    }

    if (!slides.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          slideRatios.set(entry.target, entry.intersectionRatio);
        });

        var activeIndex = 0;
        var bestRatio = 0;

        slides.forEach(function (slide, index) {
          var ratio = slideRatios.get(slide) || 0;
          if (ratio > bestRatio) {
            bestRatio = ratio;
            activeIndex = index;
          }
        });

        if (bestRatio >= 0.4) {
          updateHeaderState(activeIndex);
          updateActiveMedia(activeIndex);
        }
      },
      {
        root: null,
        threshold: [0, 0.2, 0.4, 0.6, 0.8, 1],
      }
    );

    slides.forEach(function (slide) {
      slideRatios.set(slide, 0);
      observer.observe(slide);
    });

    updateHeaderState(0);
    updateActiveMedia(0);
  }

  function initSplideSlider(sliderEl) {
    var root = document.documentElement;
    var sectionHeader = document.querySelector('.section-header');
    var sliderHeight = function () {
      return window.innerHeight + 'px';
    };

    sliderEl.style.height = sliderHeight();

    var splide = new Splide(sliderEl, {
      direction: 'ttb',
      height: sliderHeight(),
      wheel: true,
      releaseWheel: true,
      wheelSleep: 500,
      wheelMinThreshold: 20,
      pagination: false,
      arrows: false,
      drag: true,
      speed: 800,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    });

    function updateHeaderState(index) {
      root.classList.add('customdown-scroll-active');

      if (sectionHeader) {
        sectionHeader.classList.toggle('header-has-bg', index > 0);
      }
    }

    splide.on('mounted', function () {
      updateHeaderState(splide.index);
      setActiveMedia(sliderEl, splide.index);
    });

    splide.on('moved', function (newIndex) {
      updateHeaderState(newIndex);
      setActiveMedia(sliderEl, newIndex);
    });

    splide.on('move', function (newIndex) {
      updateHeaderState(newIndex);
    });

    splide.mount();

    window.addEventListener(
      'resize',
      function () {
        var height = sliderHeight();
        sliderEl.style.height = height;
        splide.options = { height: height };
        splide.refresh();
        setActiveMedia(sliderEl, splide.index);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomdownSlider);
  } else {
    initCustomdownSlider();
  }
})();
